module.exports = __webpack_public_path__ + "img/ring_g_0_0_0@3x.5686ea8c.png";